<div class="row">
  <div class="col-12" style="text-align: right;">
    <button class="btn btn-success btn-md" (click)="saveEmit('create')">
      <i class="fa fa-plus" aria-hidden="true"></i> &nbsp; {{new_button}}
    </button>
  </div>
</div>

<div class="material-datatables">
  <table id="table_tickets" class="table table-striped table-no-bordered table-hover" cellspacing="0" width="100%" style="width:100%">

    <thead>
      <tr>
          <th> <b> Id </b> </th>
          <th> <b> Requested by </b> </th>
          <th> <b> Type </b> </th>
          <th> <b> Date </b> </th>
          <th> <b> Deadline </b> </th>
          <th> <b> # Of Items </b> </th>
          <th> <b> Destination </b> </th>
          <th> <b> Assigned to </b> </th>
          <th> <b> Status </b> </th>

          <th class="disabled-sorting" style="text-align: right;"> <b>Actions</b> </th>
      </tr>
    </thead>

    <tbody>
      <tr *ngFor="let row of dataTable.dataRows">
        <td>{{row[0]}}</td>
        <td>{{row[7]}}</td>
        <td>{{row[1]}}</td>
        
        <td>{{row[3] | date : 'short'}}</td>
        <td>{{row[8]}}</td>
        <td>{{row[5]}}</td>
        <td>{{row[6]}}</td>
        <td>{{row[9]}}</td>
        <td>
          <button *ngIf="row[2] === 'pending'" class="btn btn-sm btn-warning" (click)="saveEmit('changeStatus', row[0], row)">
            Pending
          </button>
          <button *ngIf="row[2] === 'received'" class="btn btn-sm btn-info" (click)="saveEmit('changeStatus', row[0], row)">
            Delivered
          </button>
          <button *ngIf="row[2] === 'COMPLETED'" class="btn btn-sm btn-success" (click)="saveEmit('changeStatus', row[0], row)">
            Completed
          </button>
        </td>

        <td style="text-align: right;">
          <label *ngFor="let boton of buttons">

            <a *ngIf="
            boton.enabled && 
            boton.type === 'just-icon' && 
            ( 
            (row[4] === 0) || (boton.action == 'show')
            ) "
              class="btn btn-link {{boton.color}} btn-just-icon" 
              (click)="saveEmit(boton.action, row[0], row)">
            <i class="material-icons">{{boton.icon}}</i></a>

            <button *ngIf="boton.enabled && boton.type === 'btn'"
                    class="btn btn-sm btn-{{boton.color}}" (click)="saveEmit(boton.action, row[0], row)">
              <i class="material-icons">{{boton.icon}}</i> &nbsp; {{boton.action}}
            </button>
          </label>
          
        </td>
      </tr>
    </tbody>

  </table>
</div>